module.exports = __webpack_public_path__ + "static/media/zoom-in.5788b3fa.svg";